import messageVue from './main.vue'
// import { guid } from '../../../src/utils/utils'
// 定义插件对象
const IpubMessage = {}
// const box = {}
// vue的install方法，用于定义vue插件
IpubMessage.install = function(Vue) {
  const MessageBoxInstance = Vue.extend(messageVue)
  let currentMsg
  const initInstance = () => {
    // 实例化vue实例
    currentMsg = new MessageBoxInstance()
    let $el = currentMsg.$mount().$el
    document.body.appendChild($el)
    // const uuid = guid()
    // currentMsg.uuid = uuid
    // box[uuid] = currentMsg
  }
  const mesFun = (options, time, type) => {
    initInstance()
    if (typeof options === 'string') {
      currentMsg.content = options
    } else if (typeof options === 'object') {
      Object.assign(currentMsg, options)
    }
    if (time) {
      currentMsg.time = time
    }
    if (type) {
      currentMsg.type = type
    }
    //  Object.assign方法只会拷贝源对象自身的并且可枚举的属性到目标对象
    return currentMsg
      .createMessage()
      .then(val => {
        currentMsg = null
        return Promise.resolve(val)
      })
      .catch(err => {
        currentMsg = null
        return Promise.reject(err)
      })
  }
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$message = (options, time) => {
    return mesFun(options, time)
  }
  Vue.prototype.$message.success = (options, time) => {
    return mesFun(options, time, 'success')
  }
  Vue.prototype.$message.error = (options, time) => {
    return mesFun(options, time, 'error')
  }
  Vue.prototype.$message.warning = (options, time) => {
    return mesFun(options, time, 'warning')
  }
}
export default IpubMessage
